import { Integration } from "./Integration";

export class IntegrationFeedback {
    integration: Integration;
    integrationName: String;
    timestamp: String;
    transactionId: String;
    result: IntegrationFeedbackResultEnum;

    static parse(data: any): IntegrationFeedback {
        var res = new IntegrationFeedback();
        res.integrationName = data.IntegrationName;
        res.timestamp = data.Timestamp;
        res.transactionId = data.TransactionId;
        res.result = data.Result;

        if (data.Integration) {
            res.integration = Integration.parse(data.Integration);
        }
        return res;
    }
}

export enum IntegrationFeedbackResultEnum {
    Unknown = 0,
    Sent = 1,
    NotToSend = 2,
}

export function GetIntegrationFeedbackResultEnumLabel(value: IntegrationFeedbackResultEnum): string {
    switch (value) {
        case IntegrationFeedbackResultEnum.Sent:
            return "enum.integrationFeedbackResult.sent";
        case IntegrationFeedbackResultEnum.NotToSend:
            return "enum.integrationFeedbackResult.notToSend";
        default:
            return "common.unknown";
    }
}
